"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformUserToContact = transformUserToContact;
const class_transformer_1 = require("class-transformer");
const Contact_1 = require("../models/Contact");
const transformUserBirthdayToDate_1 = require("./transformUserBirthdayToDate");
function transformUserToContact(user) {
    const rawContact = {
        birthdayAt: (0, transformUserBirthdayToDate_1.transformUserBirthdayToDate)(user.birthdayAt),
        countryId: user.countryId,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        phoneNumber: user.phoneNumber,
    };
    return (0, class_transformer_1.plainToClass)(Contact_1.Contact, rawContact);
}
//# sourceMappingURL=transformUserToContact.js.map